import React from "react";
import DataTable from "react-data-table-component";
import SKAlerts from "../../shared/common-alerts/SKAlerts";
import * as Icons from "react-feather";

function ModulePermissionGrid(props) {

  const customStyles = {
    rows: {
      style: {
        minHeight: '35px', // 👈 reduce from default 56px
        paddingTop: '2px',
        paddingBottom: '2px'
      }
    },
    headCells: {
      style: {
        paddingTop: '4px',
        paddingBottom: '4px',
        fontSize: '14px'
      }
    },
    cells: {
      style: {
        paddingTop: '2px',
        paddingBottom: '2px',
        fontSize: '13px'
      }
    }
  };

  function getCheckBoxId(row, action){
    var base = "";
    if(!row.items){
      base = row.ModuleName ? row.ModuleName.replace(/\s/g, "") : "Module";
    } else {
      base = row.groupName ? row.groupName.replace(/\s/g, "") : "Module";
    }
    return `${base}${action}`;
  }
  const columnsGroupRow =[
    {
      cell: row => (<span></span>),
      width: "50px"  // ✅ correct: fixed width
    },
    {
      selector: row => row.ModuleName,
      cell: row => <span title={row.ModuleName}>{row.ModuleName}</span>,
    },
    {
      name: <div className="titlename"><span>View</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "View")} className="check" checked={ row.ViewModule === 1 ? true : false} disabled={props.isSavingPermissions} onChange={(e) => props.onPermissionToggle(e,row,"View")} />
            <label htmlFor={getCheckBoxId(row, "View")} className="checktoggle"></label>
          </div>
        </span>
      )
    },
    {
      name: <div className="titlename"><span>Add</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "Add")} className="check" checked={ row.AddModule === 1 ? true : false } disabled={props.isSavingPermissions} onChange={(e) => props.onPermissionToggle(e,row,"Add")} />
            <label htmlFor={getCheckBoxId(row, "Add")} className="checktoggle"></label>
          </div>
        </span>
      )
    },
    {
      name: <div className="titlename"><span>Edit</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "Edit")} className="check" checked={ row.EditModule === 1 ? true : false } disabled={props.isSavingPermissions}  onChange={(e) => props.onPermissionToggle(e,row,"Edit")} />
            <label htmlFor={getCheckBoxId(row, "Edit")} className="checktoggle"></label>
          </div>
        </span>
      )
    },
    {
      name: <div className="titlename"><span>Delete</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "Delete")} className="check" checked={ row.DeleteModule === 1 ? true : false } disabled={props.isSavingPermissions} onChange={(e) => props.onPermissionToggle(e,row,"Delete")} />
            <label htmlFor={getCheckBoxId(row, "Delete")} className="checktoggle"></label>
          </div>
        </span>
      )
    }
  ];
  const columnsChildRow = [
    {
      name: <div className="titlename"><span>Module Name</span></div>,
      selector: row => row.ModuleName || row.groupName,
      cell: row => (
        <span title={row.ModuleName || row.groupName}>
          {row.ModuleName || <strong>{row.groupName}</strong>}
        </span>
      )
    },
    {
      name: <div className="titlename"><span>View</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "View")} checked={ row.ViewModule === 1 ? true : false } className="check" disabled={props.isSavingPermissions}  onChange={(e) => props.onPermissionToggle(e,row,"View")} />
            <label htmlFor={getCheckBoxId(row, "View")} className="checktoggle"></label>
          </div>
        </span>
      )
    },
    {
      name: <div className="titlename"><span>Add</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "Add")} checked={ row.AddModule === 1 ? true : false } className="check" disabled={props.isSavingPermissions}  onChange={(e) => props.onPermissionToggle(e,row,"Add")} />
            <label htmlFor={getCheckBoxId(row, "Add")} className="checktoggle"></label>
          </div>
        </span>
      )
    },
    {
      name: <div className="titlename"><span>Edit</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "Edit")} checked={ row.EditModule === 1 ? true : false } className="check" disabled={props.isSavingPermissions}  onChange={(e) => props.onPermissionToggle(e,row,"Edit")} />
            <label htmlFor={getCheckBoxId(row, "Edit")} className="checktoggle"></label>
          </div>
        </span>
      )
    },
    {
      name: <div className="titlename"><span>Delete</span></div>,
      cell: row => ( 
        <span>
          <div className="status-toggle modal-status">
            <input type="checkbox" id={getCheckBoxId(row, "Delete")} checked={ row.DeleteModule === 1 ? true : false } className="check" disabled={props.isSavingPermissions} onChange={(e) => props.onPermissionToggle(e,row,"Delete")} />
            <label htmlFor={getCheckBoxId(row, "Delete")} className="checktoggle"></label>
          </div>
        </span>
      )
    }
  ];
  const GroupRow = ({ data }) => {
    return (
      <DataTable
        columns={columnsGroupRow}
        data={data.items}
        customStyles={customStyles}
        noHeader
      />
    );
  };
  const PlusMinusIcon = ({ expanded }) => (
    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
      {expanded ? <Icons.Minus size={25} color="#1261a0" style={{paddingLeft:"10px"}} /> : <Icons.Plus size={25} color="#1261a0" style={{paddingLeft:"10px"}} />}
    </div>
  );
  return (
    <>
      <div className="card table-list-card">
        <div className="card-body">
          <DataTable
            columns={columnsChildRow}
            data={props.RoleModulePermissionListData}
            expandableRows
            expandableRowsComponent={GroupRow}
            expandOnRowClicked
            expandableRowExpanded={() => true}
            expandableIcon={{
              collapsed: <PlusMinusIcon expanded={false} />,
              expanded: <PlusMinusIcon expanded={true} />
            }}
            customStyles={customStyles}
          />
        </div>
      </div>
    </>
  );
}

export default ModulePermissionGrid;
